/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Keep product tags attached to the sticky price/add-to-cart box.
(function() {
  function pinProductTagsToPurchaseBox() {
    var purchaseBox = document.querySelector('.product-single__box');
    var tags = document.querySelector('.product-single__tags');

    if (!purchaseBox || !tags || purchaseBox.contains(tags)) {
      return;
    }

    purchaseBox.appendChild(tags);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinProductTagsToPurchaseBox);
  } else {
    pinProductTagsToPurchaseBox();
  }

  document.addEventListener('shopify:section:load', pinProductTagsToPurchaseBox);
  window.addEventListener('resize', pinProductTagsToPurchaseBox);
})();
